module.exports = __webpack_public_path__ + "static/img/stop-bg.aa22fc42.png";